export enum HOD_DOS_DECISION {
  RETURN_TO_DSRC = 'RETURN',
  APPROVE = 'APPROVE',
  NA = 'NA',
}
